// extracted by mini-css-extract-plugin
module.exports = {"small":"Card_small__1PRSf","author":"Card_author__3Ha95","cardBottom":"Card_cardBottom__M6xru","subTitle":"Card_subTitle__26gd0","contentPointers":"Card_contentPointers__1JT3x"};